import React from "react"
import Layout from "../components/Layout"
import PageHero from "../components/PageHero"
import "../styles/whitepaper.scss"

import BJFCaseStudyPdf            from "../files/Visiomate_BJF_Case_Study.pdf"
import MMGCaseStudyPdf            from "../files/Visiomate_MMG_Case_Study.pdf"
import VisiomateCSPdf           from "../files/Prom_CAPABILITY_STATEMENT_Visiomate.pdf"
import VisiomateVisioedgeIntroPdf from "../files/Prom_Visioedge_Intro.pdf"
import VisiomatePortpolioERPPdf   from "../files/Prom_Visiomate_Portfolio_ERP.pdf"
import VisiomateProfilePdf        from "../files/Prom_Visiomate_Profile.pdf"


/* ── Icons ─────────────────────────────────────────────────────────── */
const IconFile = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
  </svg>
)

const IconDownload = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </svg>
)

const IconClock = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
  </svg>
)

const IconPages = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="14" height="18" rx="2" /><path d="M7 7h6M7 11h6M7 15h4" />
  </svg>
)

const IconWhitepaper = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <line x1="10" y1="9" x2="8" y2="9" />
  </svg>
)

const IconCaseStudy = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <line x1="8" y1="21" x2="16" y2="21" />
    <line x1="12" y1="17" x2="12" y2="21" />
    <polyline points="6 9 10 13 14 10 18 14" />
  </svg>
)

const IconMegaphone = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 11l19-9-9 19-2-8-8-2z" />
  </svg>
)

/* ── Data ─────────────────────────────────────────────────────────── */
const CATEGORIES = [
  {
    key: "casestudies",
    Icon: IconCaseStudy,
    title: "Case Study PDFs",
    subtitle: "Real-world results from digital transformation projects delivered by Visiomate",
    badgeBg: "#f0fdf4",
    badgeColor: "#15803d",
    badgeLabel: "Case Study",
    items: [
      {
        href: BJFCaseStudyPdf,
        title: "Big Jerry's Fencing — End-to-End Automation",
        desc: "How Visiomate unified CRM, quoting, project management, and a customer portal across 21 cities in 9 U.S. states.",
        pages: "1",
        updated: "2025",
      },
      {
        href: MMGCaseStudyPdf,
        title: "Muscat Media Group — HR Automation on Odoo",
        desc: "How MMG eliminated spreadsheet-based HR processes and automated leave, attendance, gratuity, and payroll on Odoo 13.",
        pages: "1",
        updated: "2025",
      },
      {
        href: null,
        title: "Orangeline Pakistan — Construction Management",
        desc: "How Visiomate delivered a centralized planning, approval, and real-time monitoring solution for Pakistan's Orange Line Train project.",
        pages: null,
        updated: null,
        comingSoon: true,
      },
      {
        href: null,
        title: "Nurtureful Psychology — Digital Transformation",
        desc: "End-to-end digital ecosystem for a premier mental health practice covering booking, telehealth, billing, and patient self-service.",
        pages: null,
        updated: null,
        comingSoon: true,
      },
    ],
  },
  {
    key: "whitepaper",
    Icon: IconWhitepaper,
    title: "Whitepapers",
    subtitle: "In-depth technical documentation on our platforms, products, and integrations",
    badgeBg: "#eff6ff",
    badgeColor: "#1b2d8e",
    badgeLabel: "Whitepaper",
    items: [    ],
  },
  {
    key: "promo",
    Icon: IconMegaphone,
    title: "Promotional Documents",
    subtitle: "Company profiles, service brochures, and portfolio documents",
    badgeBg: "#fdf4ff",
    badgeColor: "#9333ea",
    badgeLabel: "Brochure",
    items: [
      {
        href: VisiomateProfilePdf,
        title: "Visiomate Company Profile",
        desc: "Our story, services, team structure, and past project portfolio — the complete company overview for prospective partners.",
        pages: "20",
        updated: "2024",
      },
      {
        href: VisiomatePortpolioERPPdf,
        title: "Visiomate ERP Portfolio",
        desc: "Visiomate is an Odoo Certified Partner delivering implementation, customization, and support — plus expert Microsoft Dynamics 365 services for growing businesses worldwide.",
        pages: "16",
        updated: "2023",
      },
       {
        href: VisiomateCSPdf,
        title: "Visiomate — Capability Statement",
        desc: "We delivers AI-powered web apps, custom internal tools, and SaaS platforms for SMEs — senior engineering, built to scale and last.",
        pages: "6",
        updated: "2026",
      },
      {
        href: VisiomateVisioedgeIntroPdf,
        title: "Visioedge (powered by Odoo community) — Localized Solution for Restaurants & Retailers",
        desc: "A concise product brochure for the Visioedge system, designed for sharing with restaurant and retail prospects.",
        pages: "6",
        updated: "2024",
      },
    ],
  },
]

/* ── Component ─────────────────────────────────────────────────────── */
const WhitepapereBooks = () => (
  <div className="CaseStudeies wp-page">
    <Layout
      pageTitle="Visiomate — Downloads"
      descrip="Download case study PDFs, whitepapers, and promotional documents from Visiomate. Real-world results and expert insights on ERP, AI, and custom software."
    >
      <PageHero
        eyebrow="Information Hub"
        title="Downloads & Resources"
        description="Case study PDFs, technical whitepapers, and promotional documents — everything you need to understand what Visiomate builds and the results we deliver."
      />

      <div className="wp-body">
        {CATEGORIES.map(cat => (
          <div key={cat.key} className="wp-category">
            {/* Section header */}
            <div className="wp-category__header">
              <div className="wp-category__header-left">
                <div className="wp-category__header-icon">
                  <cat.Icon />
                </div>
                <div>
                  <h2 className="wp-category__title">{cat.title}</h2>
                  <p className="wp-category__subtitle">{cat.subtitle}</p>
                </div>
              </div>
              <span className="wp-category__count">
                {cat.items.filter(i => !i.comingSoon).length} available
              </span>
            </div>

            {/* Document list */}
            <div className="wp-category__list">
              {cat.items.map(item => (
                <div key={item.title} className="wp-item">
                  {/* File icon */}
                  <div className="wp-item__icon">
                    <IconFile />
                    <span className="wp-item__icon-ext">PDF</span>
                  </div>

                  {/* Body */}
                  <div className="wp-item__body">
                    <div className="wp-item__meta">
                      <span
                        className="wp-item__badge"
                        style={{
                          background: cat.badgeBg,
                          color: cat.badgeColor,
                        }}
                      >
                        {cat.badgeLabel}
                      </span>
                      {item.comingSoon && (
                        <span
                          className="wp-item__badge"
                          style={{ background: "#f3f4f6", color: "#9ca3af" }}
                        >
                          Coming Soon
                        </span>
                      )}
                    </div>
                    <h3 className="wp-item__title">{item.title}</h3>
                    <p className="wp-item__desc">{item.desc}</p>
                    {!item.comingSoon && (
                      <div className="wp-item__info">
                        {item.pages && (
                          <span>
                            <IconPages /> {item.pages} pages
                          </span>
                        )}
                        {item.updated && (
                          <span>
                            <IconClock /> Updated {item.updated}
                          </span>
                        )}
                        <span>PDF format</span>
                      </div>
                    )}
                  </div>

                  {/* Action */}
                  <div className="wp-item__action">
                    {item.comingSoon ? (
                      <span className="wp-item__btn wp-item__btn--coming">
                        Coming Soon
                      </span>
                    ) : (
                      <a
                        href={item.href}
                        download
                        target="_blank"
                        rel="noreferrer"
                        className="wp-item__btn"
                      >
                        <IconDownload /> Download
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </Layout>
  </div>
)

export default WhitepapereBooks

